module.exports = __webpack_public_path__ + "media/packs/images/flags/AS-a0f3d4919821ef6bb00fd7c37bc5939d.svg";